import ipadProIcon from '@/assets/device-icons/ipad-pro.svg';

interface IpadProIconProps {
  className?: string;
}

export const IpadProIcon = ({ className = "h-5 w-5" }: IpadProIconProps) => {
  return (
    <img 
      src={ipadProIcon} 
      alt="iPad Pro" 
      className={className}
    />
  );
};
